import { BENEFITS } from "@/data/site";
import { Reveal, useLang } from "./common";

export const Benefits = () => {
  const { t } = useLang();
  return (
    <section id="benefits" data-testid="benefits-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="font-mono2 text-xs tracking-[0.25em] uppercase mb-5 text-[#00A651]">{t.benefits.num} — {t.benefits.kicker}</p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#0F295B]">
                {t.benefits.title[0][0]}<span className="text-[#D97D00]">{t.benefits.title[1][0]}</span>{t.benefits.title[2][0]}
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-10 relative rounded-[2rem] overflow-hidden aspect-[4/3]">
              <img src="/assets/tech.jpg" alt={t.benefits.imgAlt} className="absolute inset-0 w-full h-full object-cover" />
            </Reveal>
          </div>
        </div>
        <ol className="lg:col-span-7" data-testid="benefits-list">
          {t.benefits.items.map((b, i) => (
            <Reveal key={b} delay={0.03 * i} y={20}>
              <li data-testid={`benefit-${i}`} className="group flex gap-6 sm:gap-10 py-7 border-b border-[#0F295B]/10">
                <span className="font-display text-3xl sm:text-4xl text-[#0F295B]/15 group-hover:text-[#00A651] transition-colors w-14 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <p className="text-lg sm:text-xl text-[#0F295B] font-medium leading-snug pt-1">{b}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
